import { FetchStatus } from '../types/fetch-status.types'

const defaultValues: FetchStatus = {
  isLoading: false,
  isError: false,
  isSuccess: false,
}

const fetchStatus = {
  default: defaultValues,
}

export default fetchStatus
